import { FC, useEffect } from 'react';

import styled from '@emotion/styled';
import { Exam } from 'store/my-registrations/types';
import { ReadonlyField } from 'components';
import { useLazyGetCancellationInfoQuery } from 'store/my-registrations/myRegistrationsAPI';

import { Modal } from '@britishcouncil/react-solas-ors3';
import { Button } from '@britishcouncil/react-solas';

export const ExamCancelInfoModal: FC<{ exam: Exam; onExit: () => void }> = ({ exam, onExit }) => {
  const [getCancellationInfo, { data: cancelInfo, isFetching }] = useLazyGetCancellationInfoQuery();

  useEffect(() => {
    if (exam.isCanceled) {
      getCancellationInfo(exam.id);
    }
  }, [exam, getCancellationInfo]);

  return (
    <Modal
      show={true}
      title="Exam cancellation"
      onExit={onExit}
      isLoading={isFetching}
      footer={
        <Footer>
          <Button intent="primary" onClick={onExit}>
            Ok
          </Button>
        </Footer>
      }
    >
      <Container>
        {!exam.isCanceled ? (
          <p>
            Entry fees will only be refunded if the British Council is notified of the withdrawal of the candidate
            before the published entry closing date. However, we will consider requests, in writing, for refunds of
            entry fees on medical grounds after the published entry closing date. The application must be submitted in
            writing and be accompanied by medical evidence confirming that the candidate was unable to sit the
            examination.
          </p>
        ) : (
          <>
            <ReadonlyField label="Cancellation reason">{cancelInfo?.cancellationReason}</ReadonlyField>
            <ReadonlyField label="Cancellation info">{cancelInfo?.cancellationNote}</ReadonlyField>
            <ReadonlyField label="Cancellation date">{cancelInfo?.cancellationDate}</ReadonlyField>
            <ReadonlyField label="Cancelled by">{cancelInfo?.cancellationCreator}</ReadonlyField>
          </>
        )}
      </Container>
    </Modal>
  );
};

const Footer = styled.div`
  display: flex;
  justify-content: space-between;
`;

const Container = styled.div`
  max-width: 632px;
`;
